import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972|0)(?:5\d|[2-9]\d|7\d)\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^https:\/\/www\.linkedin\.com\/in\//,
  email:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  nonRequiredEmail:
    /^$|(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  idNumber: /^\d+$/,
}

export const invalid = {
  firstName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  lastName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  phoneNumber: "מספר נייד לא תקין",
  email: "כתובת האימייל אינה תקינה",
  allPhoneNumber: "מספר טלפון לא תקין",
  description: "כאן צריך לכתוב בקצרה מדוע החלטת לשלוח פנייה",
  ID: 'מספר ת"ז/ח"פ לא תקין',
  linkedin: "הקישור אינו תקינה",
  subject: "subject error",
}

export const schemaDonationRequest = {
  stringValue: yup.string().min(1).max(50).required("required"),
  booleanValue: yup.string().max(50).required("required"),
  numberValue: yup
    .string()
    .matches(/^[0-9]+$/)
    .required("required"),
}

export const messagesInvalid = {
  en: {
    firstName: "Letters must be typed in Hebrew or English only and without special symbols",
    phoneNumber: "The phone number entered is incorrect",
    email: "The email address entered is invalid",
    requiredName: "First name and last name must be filled in",
    requiredPhoneNumber: "A phone number must be entered",
    requiredEmail: "An email address must be entered",
    subject: "You must choose subject",
    requiredIdNumber: "ID number is required",
    allowedMarketing: "You must accept the marketing terms",
    requiredFullName: "First name and last name must be filled in",
  },
  he: {
    firstName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
    phoneNumber: "מספר הטלפון שהוזן אינו תקין",
    email: "כתובת האימייל שהוזנה אינה תקינה",
    requiredName: "יש למלא שם פרטי ושם משפחה",
    requiredPhoneNumber: "יש להזין מספר טלפון",
    requiredEmail: "יש להזין כתובת מייל",
    subject: "עליך לבחור נושא",
    requiredIdNumber: "יש להזין מספר תעודת זהות",
    allowedMarketing: "עליך לאשר את תנאי השיווק",
    requiredFullName: "יש למלא שם פרטי ושם משפחה",
  },
}

export const messagesInvalidLanding = {
  en: {
    firstName: "Letters must be typed in Hebrew or English only and without special symbols",
    phoneNumber: "The phone number entered is incorrect",
    email: "The email address entered is invalid",
    requiredName: "First name and last name must be filled in",
    requiredPhoneNumber: "A phone number must be entered",
    requiredEmail: "An email address must be entered",
    requiredCheckbox: "This field is required",
    requiredSelect: "A selection must be made",
    requiredFullName: "First name and last name must be filled in",
  },
  he: {
    firstName: "השם שהוזן אינו תקין",
    phoneNumber: "מספר הטלפון שהוזן אינו תקין",
    email: "כתובת המייל שהוזנה אינה תקינה",
    requiredName: "יש למלא את השדה",
    requiredPhoneNumber: "יש למלא את השדה",
    requiredEmail: "יש למלא את השדה",
    requiredCheckbox: "יש לסמן את השדה",
    requiredSelect: "יש לבחור שדה",
    requiredFullName: "יש למלא שם פרטי ושם משפחה",
  },
}

export const messagesInvalidNew = {
  en: {
    firstName: "Only Hebrew and English letters allowed",
    phoneNumber: "The phone number entered is incorrect",
    email: "Proper email structure (e.g., example@email.com).",
    requiredName: "Field must be filled",
    requiredPhoneNumber: "Field must be filled",
    requiredEmail: "Field must be filled",
    subject: "You must choose subject",
    requiredFullName: "First name and last name must be filled in",
  },
  he: {
    firstName: "ניתן להזין רק אותיות עברית ואנגלית",
    phoneNumber: "מספר הטלפון שהוזן אינו תקין",
    email: "מבנה כתובת אימייל חוקי (לדוגמה: example@email.com)",
    requiredName: "חובה למלא את השדה",
    requiredPhoneNumber: "חובה למלא את השדה",
    requiredEmail: "חובה למלא את השדה",
    subject: "עליך לבחור נושא",
    requiredFullName: "יש למלא שם פרטי ושם משפחה",
  },
}
type Language = "en" | "he"

export const schemaCommon = {
  firstName: yup
    .string()
    .matches(regex.singleName, invalid.firstName)
    .max(25, invalid.firstName)
    .required("אנחנו צריכים לדעת מה השם שלך"),
  lastName: yup
    .string()
    .matches(regex.singleName, invalid.lastName)
    .max(25, invalid.lastName)
    .required("צריך למלא גם שם משפחה"),
  fullName: yup
    .string()
    .matches(regex.singleName, invalid.firstName)
    .test("two-words", "אנחנו צריכים לדעת מה השם שלך", (value) =>
      !value ? true : value.trim().split(/\s+/).length >= 2,
    )
    .max(50, invalid.firstName)
    .required("אנחנו צריכים לדעת מה השם שלך"),
  ID: yup.string().matches(regex.IDCompanyId, invalid.ID).required('אנא הקלד ת"ז/ח"פ'),
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, invalid.phoneNumber)
    .length(10, invalid.phoneNumber)
    .required("מה מספר הנייד שלך? צריך למלא, כדי שנחזור אליך")
    .max(10, invalid.phoneNumber),
  city: yup.string().required("צריך לנסות להקליד את שם העיר שוב"),
  email: yup
    .string()
    .matches(regex.email, invalid.email)
    .required("אנחנו צריכים לקבל את כתובת האימייל שלך"),
  allPhoneNumber: yup
    .string()
    .matches(regex.allPhoneNumber, invalid.allPhoneNumber)
    .required("מה המספר שלך? צריך למלא, כדי שנחזור אליך")
    .max(13, invalid.allPhoneNumber),
  description: yup.string().required(invalid.description).max(500, invalid.description),
  comments: yup.string().nullable().notRequired(),
  subject: yup.string().min(1).required(),
  file: yup.string().required("required"),
  fileName: yup.string().required("required"),
  linkedin: yup.string().matches(regex.linkedin, invalid.linkedin),
  subscrube: yup.boolean().required(),
  jobId: yup.string().required(),
  emailNonRequired: yup.string().matches(regex.nonRequiredEmail, invalid.email).nullable(),
}

export const generateSchema = (language: Language) => {
  const msg = messagesInvalid[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .max(50, msg.firstName)
      .required(msg.requiredName),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    message: yup.string().nullable().notRequired(),
    subject: yup.string().min(1, msg.subject).required(msg.subject),
  })
}

export const generateSchemaNew = (language: Language) => {
  const msg = messagesInvalidNew[language]

  return yup.object({
    fullName: yup
      .string()
      .required(msg.requiredName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .min(2, msg.firstName)
      .max(50, msg.firstName)
      .matches(regex.singleName, msg.firstName),
    email: yup.string().required(msg.requiredEmail).matches(regex.email, msg.email),
    phone: yup
      .string()
      .required(msg.requiredPhoneNumber)
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .max(13, msg.phoneNumber),
    message: yup.string().nullable().notRequired(),
    subject: yup.string().min(1, msg.subject).required(msg.subject),
  })
}
export const generateGenericSchema = (language: Language) => {
  const msg = messagesInvalid[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .max(50, msg.firstName)
      .required(msg.requiredName),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    message: yup.string().nullable().notRequired(),
  })
}

export const generateRentAppartmentContactSchema = (language: Language) => {
  const msg = messagesInvalid[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .max(50, msg.firstName)
      .required(msg.requiredName),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    message: yup.string().nullable().notRequired(),
    allowedMarketing: yup.boolean().oneOf([true]).required(msg.allowedMarketing),
  })
}

export const generateRentAppartmentPaymentSchema = (language: Language) => {
  const msg = messagesInvalid[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .max(50, msg.firstName)
      .required(msg.requiredName),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    idNumber: yup
      .string()
      .matches(regex.idNumber, msg.requiredIdNumber)
      .required(msg.requiredIdNumber),
    checkbox1: yup.boolean().oneOf([true]).required(),
    checkbox2: yup.boolean().optional(),
  })
}

export const generateGenericSchemaLanding = (language: Language) => {
  const msg = messagesInvalidLanding[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .min(2, msg.firstName)
      .max(20, msg.firstName)
      .required(msg.requiredName),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    message: yup.string().nullable().notRequired(),
  })
}

export const generateRentalHousingFormSchema = (language: Language) => {
  const msg = messagesInvalid[language]
  const nameMsg =
    language === "he"
      ? "יש להזין לפחות 2 תווים באותיות עברית או אנגלית"
      : "Minimum 2 characters, Hebrew or English only"
  const requiredField = language === "he" ? "שדה חובה" : "Required field"

  return yup.object({
    firstName: yup
      .string()
      .matches(regex.singleName, nameMsg)
      .min(2, nameMsg)
      .max(25, nameMsg)
      .required(requiredField),
    lastName: yup
      .string()
      .matches(regex.singleName, nameMsg)
      .min(2, nameMsg)
      .max(25, nameMsg)
      .required(requiredField),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    project: yup
      .string()
      .required(language === "he" ? "יש לבחור פרויקט מהרשימה" : "Please select a project"),
    rooms: yup
      .array()
      .of(yup.string().required())
      .min(
        1,
        language === "he" ? "יש לבחור מספר חדרים מהרשימה" : "Please select the number of rooms",
      )
      .required(
        language === "he" ? "יש לבחור מספר חדרים מהרשימה" : "Please select the number of rooms",
      ),
    entryDateType: yup
      .string()
      .oneOf(["immediate", "flexible", "specific"])
      .required(
        language === "he" ? "יש לבחור מועד כניסה מבוקש" : "Please select a preferred move-in date",
      ),
    specificDate: yup.string().when("entryDateType", {
      is: "specific",
      then: (schema) =>
        schema.required(
          language === "he"
            ? "יש לבחור מועד כניסה מבוקש"
            : "Please select a preferred move-in date",
        ),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    notes: yup.string().nullable().notRequired().max(500),
  })
}

/**
 * @param requireProject - true when the landing page defines a project list, so the
 *   project dropdown is rendered and must be selected before submitting.
 */
export const generateLandingLeadFormSchema = (
  language: Language,
  requireProject = false,
  requiredFields = { fullName: true, email: true, phone: true },
) => {
  const msg = messagesInvalidLanding[language]

  const fullNameSchema = requiredFields.fullName
    ? yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .test("two-words", msg.requiredFullName, (value) =>
          !value ? true : value.trim().split(/\s+/).length >= 2,
        )
        .min(2, msg.firstName)
        .max(50, msg.firstName)
        .required(msg.requiredName)
    : yup
        .string()
        .optional()
        .matches(regex.singleName, { message: msg.firstName, excludeEmptyString: true })
        .max(50, msg.firstName)

  const emailSchema = requiredFields.email
    ? yup.string().matches(regex.email, msg.email).required(msg.requiredEmail)
    : yup
        .string()
        .optional()
        .matches(regex.email, { message: msg.email, excludeEmptyString: true })

  const phoneSchema = requiredFields.phone
    ? yup
        .string()
        .matches(regex.allPhoneNumber, msg.phoneNumber)
        .required(msg.requiredPhoneNumber)
        .max(13, msg.phoneNumber)
    : yup
        .string()
        .optional()
        .matches(regex.allPhoneNumber, { message: msg.phoneNumber, excludeEmptyString: true })
        .max(13, msg.phoneNumber)

  return yup.object({
    project: yup
      .string()
      .optional()
      .test("project-required", msg.requiredSelect, (value) => !requireProject || !!value),
    fullName: fullNameSchema,
    email: emailSchema,
    phone: phoneSchema,
    message: yup.string().nullable().notRequired(),
    allowMarketing: yup.boolean().optional().default(false),
    acceptTerms: yup.boolean().oneOf([true], msg.requiredCheckbox).required(msg.requiredCheckbox),
  })
}

export const messagesInvalidPortForm = {
  en: {
    firstName: "Only Hebrew and English letters allowed",
    phoneNumber: "The phone number entered is incorrect",
    email: "The email address entered is invalid",
    requiredName: "Field must be filled",
    requiredPhoneNumber: "Field must be filled",
    requiredEmail: "Field must be filled",
    requiredSelect: "Please select an option",
    requiredCheckbox: "This field is required",
    requiredFullName: "First name and last name must be filled in",
  },
  he: {
    firstName: "ניתן להזין רק אותיות עברית ואנגלית",
    phoneNumber: "מספר הטלפון שהוזן אינו תקין",
    email: "כתובת המייל שהוזנה אינה תקינה",
    requiredName: "יש למלא את השדה",
    requiredPhoneNumber: "יש למלא את השדה",
    requiredEmail: "יש למלא את השדה",
    requiredSelect: "יש לבחור אפשרות",
    requiredCheckbox: "יש לסמן את השדה",
    requiredFullName: "יש למלא שם פרטי ושם משפחה",
  },
}

export const generatePortFormSchema = (language: Language) => {
  const msg = messagesInvalidPortForm[language]

  return yup.object({
    fullName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .test("two-words", msg.requiredFullName, (value) =>
        !value ? true : value.trim().split(/\s+/).length >= 2,
      )
      .min(2, msg.firstName)
      .max(50, msg.firstName)
      .required(msg.requiredName),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    companyName: yup.string().nullable().notRequired(),
    email: yup.string().matches(regex.email, msg.email).required(msg.requiredEmail),
    interestedIn: yup
      .array()
      .of(yup.string())
      .min(1, msg.requiredSelect)
      .required(msg.requiredSelect),
    numberOfPeople: yup.string(),
    location: yup.string().min(1, msg.requiredSelect).required(msg.requiredSelect),
    preferredDate: yup.date().nullable().required(msg.requiredSelect),
    allowMarketing: yup.boolean().optional().default(false),
    acceptTerms: yup.boolean().optional().default(false),
  })
}
